// extracted by mini-css-extract-plugin
export var cardIcon = "_9e-5";
export var cardIconUnframed = "_9e-9";
export var checkboxCard = "_9e-0";
export var checkboxCardSelected = "_9e-4";
export var disabled = "_9e-2";
export var interactive = "_9e-1";
export var outerBorder = "_9e-3";
export var spacerMedium = "_9e-8";
export var spacerSmall = "_9e-7";
export var spacerXsmall = "_9e-6";